// Shared ApiResponse types that mirror the backend contract
export interface ApiResponseBase {
  success: boolean;
  message: string;
  data?: unknown | null;
  errors?: unknown | null;
}

export interface ApiResponse<T = unknown> extends ApiResponseBase {
  data?: T | null;
}

export type AnyApiResponse<T = unknown> = ApiResponse<T> | ApiResponseBase;

// A typed error you can catch when ensureSuccess throws
export class ApiError extends Error {
  public readonly errors?: unknown;
  public readonly response?: AnyApiResponse;
  constructor(message: string, options?: { errors?: unknown; response?: AnyApiResponse }) {
    super(message);
    this.name = 'ApiError';
    this.errors = options?.errors;
    this.response = options?.response;
  }
}
